/**
 * Messages 消息页面翻译
 */

import type { TranslationDict } from '../types';

export const messages: TranslationDict = {
  pageTitle: {
    en: 'Messages',
    'zh-CN': '消息',
    ja: 'メッセージ',
  },
  searchPlaceholder: {
    en: 'Search conversations...',
    'zh-CN': '搜索对话...',
    ja: '会話を検索...',
  },
  newMessage: {
    en: 'New Message',
    'zh-CN': '新消息',
    ja: '新規メッセージ',
  },
  noConversations: {
    en: 'No conversations yet',
    'zh-CN': '暂无对话',
    ja: 'まだ会話がありません',
  },
  noConversationsFound: {
    en: 'No conversations found',
    'zh-CN': '未找到对话',
    ja: '会話が見つかりません',
  },
  startChat: {
    en: 'Start a conversation',
    'zh-CN': '开始对话',
    ja: '会話を始める',
  },
  online: {
    en: 'Online',
    'zh-CN': '在线',
    ja: 'オンライン',
  },
  offline: {
    en: 'Offline',
    'zh-CN': '离线',
    ja: 'オフライン',
  },
  typing: {
    en: 'Typing...',
    'zh-CN': '正在输入...',
    ja: '入力中...',
  },
  send: {
    en: 'Send',
    'zh-CN': '发送',
    ja: '送信',
  },
  inputPlaceholder: {
    en: 'Type a message...',
    'zh-CN': '输入消息...',
    ja: 'メッセージを入力...',
  },
  emptyStateTitle: {
    en: 'Your Messages',
    'zh-CN': '你的消息',
    ja: 'メッセージ一覧',
  },
  emptyStateDescription: {
    en: 'Select a conversation from the sidebar to view your messages, or start a new conversation.',
    'zh-CN': '从侧边栏选择对话查看消息，或开始新的对话。',
    ja: 'サイドバーから会話を選択するか、新しい会話を始めてください。',
  },

  // Tabs
  tabChats: { en: 'Chats', 'zh-CN': '对话', ja: 'チャット' },
  tabFriends: { en: 'Friends', 'zh-CN': '好友', ja: '友達' },
  tabGroups: { en: 'Groups', 'zh-CN': '群组', ja: 'グループ' },

  // Header actions
  addFriend: { en: 'Add friend', 'zh-CN': '添加好友', ja: '友達を追加' },
  createGroup: { en: 'Create group', 'zh-CN': '创建群组', ja: 'グループを作成' },

  // CTAs
  findFriends: { en: 'Find Friends', 'zh-CN': '寻找好友', ja: '友達を探す' },
  newGroup: { en: 'New Group', 'zh-CN': '新建群组', ja: '新規グループ' },
  startWithFriends: {
    en: 'Start a conversation with your friends',
    'zh-CN': '和你的好友开始对话',
    ja: '友達と会話を始めましょう',
  },
  noGroupsYet: { en: 'No groups yet', 'zh-CN': '还没有群组', ja: 'グループがまだありません' },
  createOneToStart: {
    en: 'Create one to get started',
    'zh-CN': '创建一个开始使用',
    ja: '作成して始めましょう',
  },

  // Thread
  messageThreadAria: { en: 'Message thread', 'zh-CN': '消息线程', ja: 'メッセージスレッド' },
  groupThreadAria: { en: 'Group message thread', 'zh-CN': '群组消息线程', ja: 'グループメッセージスレッド' },
  moreOptions: { en: 'More options', 'zh-CN': '更多选项', ja: 'その他の操作' },
  viewMembers: { en: 'View members', 'zh-CN': '查看成员', ja: 'メンバーを表示' },

  // Modals — Create group
  groupNamePlaceholder: { en: 'Enter group name...', 'zh-CN': '输入群组名称...', ja: 'グループ名を入力...' },
  groupDescPlaceholder: {
    en: "What's this group about?",
    'zh-CN': '这个群组是关于什么的？',
    ja: 'このグループの紹介',
  },

  // Modals — Invite
  searchFriendsPlaceholder: {
    en: 'Search friends...',
    'zh-CN': '搜索好友...',
    ja: '友達を検索...',
  },

  // Create Group modal
  createGroupTitle: { en: 'Create Group', 'zh-CN': '创建群组', ja: 'グループを作成' },
  groupNameLabel: { en: 'Group Name', 'zh-CN': '群组名称', ja: 'グループ名' },
  descriptionOptional: { en: 'Description (optional)', 'zh-CN': '描述（可选）', ja: '説明（任意）' },
  visibilityLabel: { en: 'Visibility', 'zh-CN': '可见性', ja: '公開設定' },
  visibilityPrivate: { en: 'Private', 'zh-CN': '私密', ja: 'プライベート' },
  visibilityPublic: { en: 'Public', 'zh-CN': '公开', ja: '公開' },

  // Invite modal
  inviteFriendsTitle: { en: 'Invite Friends', 'zh-CN': '邀请好友', ja: '友達を招待' },

  // Join group CTA
  notJoinedGroup: {
    en: 'You are not a member of this group yet.',
    'zh-CN': '你还不是这个群组的成员。',
    ja: 'まだこのグループのメンバーではありません。',
  },
  joinButton: {
    en: 'Join Group',
    'zh-CN': '加入群组',
    ja: 'グループに参加',
  },
  groupFull: {
    en: 'This group is full (300 members max).',
    'zh-CN': '该群已满（最多 300 人）。',
    ja: 'グループが満員です（最大300人）。',
  },

  // Group switcher / embedded chat
  selectGroup: {
    en: 'Select group',
    'zh-CN': '选择群聊',
    ja: 'グループを選択',
  },
  noGroupsInCircle: {
    en: 'No group chats in this circle yet.',
    'zh-CN': '该社区还没有群聊。',
    ja: 'このサークルにはまだグループチャットがありません。',
  },
};
